
// 🚨 TODO:
// This could/should <transition>ed (fade?) to feel like it fits with toolbar panel transitions

import { defineComponent, toRefs } from "vue";
import useToolbar from "@/composables/useToolbar";

export default defineComponent({
  name: "ToolbarOutput",
  setup() {
    const { margins, current, isPassing } = useToolbar();
    const { lines } = toRefs(margins);
    const { panel } = toRefs(current);
    const { all: allPassing } = toRefs(isPassing);

    const onClick = () => {
      if (allPassing.value) return;
      panel.value = "ToolbarFixes";
    };

    return { lines, panel, onClick, allPassing };
  }
});
